import { render, staticRenderFns } from "./DoacoesModal.vue?vue&type=template&id=a45496d6&scoped=true"
import script from "./DoacoesModal.vue?vue&type=script&lang=js"
export * from "./DoacoesModal.vue?vue&type=script&lang=js"
import style0 from "./DoacoesModal.vue?vue&type=style&index=0&id=a45496d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45496d6",
  null
  
)

export default component.exports